/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { AllowedRoleMappingService } from '../../services/wealthlane-identity-services';
import { Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse } from '../../services/wealthlane-award-services';

interface PostData {
  id: string;
  payload: any;
}

const usePutAllowedRoleMapping = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse | undefined,
  any,
  PostData,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (data: PostData) => {
      return await handleRequest(
        AllowedRoleMappingService.putApiIdentityApiAppAllowedRoleMapping(data.id, data.payload)
      );
    },
    {
      onSuccess: (response) => {
        if (response != null) {
          void queryClient.invalidateQueries('getAllowedRoleMappings');
          toast.success(
            <ToastComponent label='Success' message={`Allowed Role Mapping Edited.`} />
          );
          closeModal();
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePutAllowedRoleMapping;
